import { useInsertTag, useTrackWithUser } from '@ion/api';
import TAG_TYPES from '@ion/api/tags/TAG_TYPES';

export default function useAddTag({ onClose }) {
  const [trackTagCreated] = useTrackWithUser('pipeline_tag_created');
  const [insertTag] = useInsertTag({
    onCompleted: () => {
      trackTagCreated();
      onClose();
    },
  });

  const onSubmit = ({ label }) => {
    return insertTag({ label, type: TAG_TYPES.PIPELINE });
  };

  return { onSubmit };
}
